/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */
import React, { useEffect, useMemo, useState } from "react";
import {
  PreLoading,
  CloseIconButton,
  Modal,
  ReservationDetails,
  Button,
  BookingDetails,
} from "@tripian/react";
import useTranslate from "../../../../../../hooks/useTranslate";
import Model, { helper, Providers } from "@tripian/model";
import useReservation from "../../../../../../hooks/useReservation";
import ViatorBookingDetails from "../../../../../TourInfo/ViatorTourInfo/ViatorBookingDetails/ViatorBookingDetails";
import LivnBookingTickets from "../../../../../TourInfo/LivnTourInfo/LivnBookingTickets";
import moment from "moment";
import BookingCard from "../../../../../../components/BookingCard/BookingCard";
import classes from "./MyBookingsContainer.module.scss";

interface IMyBookingsContainer {
  show: boolean;
  close: () => void;
}

const MyBookingsContainer: React.FC<IMyBookingsContainer> = ({
  show,
  close,
}) => {
  const {
    yelpReservations,
    gygReservations,
    viatorReservations,
    kiwiReservations,
    livnReservations,
    reservationCancel,
    loadingReservations,
    loadingReservation,
    initReservations,
  } = useReservation();
  const { t } = useTranslate();

  const bookingsContainerClasses = [classes.bookingsContainer];
  if (!window.tconfig.SHOW_OVERVIEW)
    bookingsContainerClasses.push("container-height");
  else bookingsContainerClasses.push("container-height-tab");
  if (show) bookingsContainerClasses.push(classes.bookingsContainerOpen);
  else bookingsContainerClasses.push(classes.bookingsContainerClose);

  const [
    yelpReservationDetailsModalState,
    setYelpReservationDetailsModalState,
  ] = useState<{
    show: boolean;
    reservationDetails?: Model.UserReservation;
  }>({
    show: false,
  });

  const [gygReservationDetailsModalState, setGygReservationDetailsModalState] =
    useState<{
      show: boolean;
      reservationDetails?: Model.UserReservation;
    }>({
      show: false,
    });

  const [
    viatorReservationDetailsModalState,
    setViatorReservationDetailsModalState,
  ] = useState<{
    show: boolean;
    reservationDetails?: Model.UserReservation;
  }>({
    show: false,
  });

  const [kiwiReservationDetailsModalState, setKiwiReservationDetailsModalState] =
    useState<{
      show: boolean;
      reservationDetails?: Model.UserReservation;
    }>({
      show: false,
    });

  const [livnReservationDetailsModalState, setLivnReservationDetailsModalState] =
    useState<{
      show: boolean;
      reservationDetails?: Model.UserReservation;
    }>({
      show: false,
    });

  useEffect(() => {
    initReservations();
  }, [initReservations]);

  /* */
  /* */
  /* ******* YELP RESERVATION DETAILS ******* */
  const memoizedYelpReservationDetailsModal = useMemo(() => {
    const yelpReservationInfo = yelpReservationDetailsModalState
      .reservationDetails?.value as Providers.Yelp.ReservationInfo;
    return (
      <Modal
        show={yelpReservationDetailsModalState.show}
        className={`${classes.bookingModal} p5`}
        backdropClick={() => {
          if (!loadingReservation)
            setYelpReservationDetailsModalState({ show: false });
        }}
      >
        <div className="row mb0">
          <div className={`${classes.tripPlannerModalCloseIcon} m2`}>
            <CloseIconButton
              fill="#fff"
              clicked={() => {
                if (!loadingReservation)
                  setYelpReservationDetailsModalState({ show: false });
              }}
            />
          </div>
          {yelpReservationDetailsModalState.reservationDetails ? (
            <div>
              {loadingReservation ? (
                <div className={classes.createUpdateTripLoading}>
                  <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
                </div>
              ) : null}
              <div>
                <ReservationDetails
                  reservationInfo={yelpReservationInfo}
                  t={t}
                />
              </div>

              {moment(
                yelpReservationDetailsModalState.reservationDetails
                  .bookingDateTime
              ).isAfter(moment()) && (
                <div className="row center">
                  <div>
                    <Button
                      color="primary"
                      text="Cancel Reservation"
                      onClick={() => {
                        setYelpReservationDetailsModalState(prevState => ({
                          ...prevState,
                        }));
                        reservationCancel(
                          yelpReservationInfo.reservation_id || ""
                        )?.then(() => {
                          setYelpReservationDetailsModalState({ show: false });
                        });
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          ) : null}
        </div>
      </Modal>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    yelpReservationDetailsModalState.show,
    yelpReservationDetailsModalState.reservationDetails,
    loadingReservation,
    reservationCancel,
  ]);

  /* */
  /* */
  /* ******* GYG RESERVATION DETAILS ******* */
  const gygReservationDetailsModal = useMemo(() => {
    const gygReservationInfo = gygReservationDetailsModalState
      .reservationDetails?.value as Providers.Gyg.TourReservationDetails;

    return (
      <Modal
        show={gygReservationDetailsModalState.show}
        className="booking-modal p5"
        backdropClick={() => {
          if (!loadingReservation)
            setGygReservationDetailsModalState({ show: false });
        }}
      >
        <div className="row m0">
          <div className="travel-guide-modal-close-icon m2">
            <CloseIconButton
              fill="#fff"
              clicked={() => {
                if (!loadingReservation)
                  setGygReservationDetailsModalState({ show: false });
              }}
            />
          </div>
          {gygReservationDetailsModalState.reservationDetails ? (
            <div>
              {loadingReservation ? (
                <div className={classes.createUpdateTripLoading}>
                  <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
                </div>
              ) : null}
              <div>
                <BookingDetails bookingInfo={gygReservationInfo} />
              </div>
              <div className={classes.bookingReservationCancelText}>
                <div>
                  Manage ticket through email confirmation from provider or
                  click link above.
                </div>
              </div>
              {/* <div className="row center">
                <div>
                  <Button
                    color="primary"
                    text="Cancel Reservation"
                    onClick={() => {
                      setGygReservationDetailsModalState((prevState) => ({
                        ...prevState,
                      }));
                      memoizedBookingCancel(gygReservationDetailsModalState.reservationDetails?.data.shopping_cart.shopping_cart_hash || "");
                    }}
                  />
                </div>
              </div> */}
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }, [
    gygReservationDetailsModalState.show,
    gygReservationDetailsModalState.reservationDetails,
    loadingReservation,
  ]);

  /* */
  /* */
  /* ******* VIATOR RESERVATION DETAILS ******* */
  const viatorReservationDetailsModal = useMemo(() => {
    const viatorReservationInfo = viatorReservationDetailsModalState
      .reservationDetails?.value as Providers.Viator.BookingReservationDetails;

    return (
      <Modal
        show={viatorReservationDetailsModalState.show}
        className="!min-w-[90%] !w-[90%] bg-background-color md:!min-w-[50%] md:!w-32 shadow-2xl rounded-3xl"
        backdropClick={() => {
          if (!loadingReservation)
            setViatorReservationDetailsModalState({ show: false });
        }}
      >
        <div className="row m0 p-4">
          <div className="absolute m-2 top-0 end-0 w-9 h-9 cursor-pointer drop-shadow-[0_3px_2px_rgba(0,0,0,1)]">
            <CloseIconButton
              fill="#fff"
              clicked={() => {
                if (!loadingReservation)
                  setViatorReservationDetailsModalState({ show: false });
              }}
            />
          </div>
          {viatorReservationDetailsModalState.reservationDetails ? (
            <div className="w-full">
              <ViatorBookingDetails
                items={viatorReservationInfo.items}
                totalConfirmedPrice={viatorReservationInfo.totalConfirmedPrice}
                voucherInfo={viatorReservationInfo.voucherInfo}
                tourName={viatorReservationInfo.tourName}
                tourImage={viatorReservationInfo.tourImage}
                travelHour={viatorReservationInfo.selectedHour}
                travelDate={viatorReservationInfo.availableDate}
                loading={loadingReservation}
                showButton={moment(
                  viatorReservationDetailsModalState.reservationDetails
                    .bookingDateTime
                ).isAfter(moment())}
                buttonText={t(
                  "trips.myTrips.localExperiences.tourDetails.cancelReservation"
                )}
                clicked={() => {
                  setViatorReservationDetailsModalState(prevState => ({
                    ...prevState,
                  }));
                  reservationCancel(
                    viatorReservationInfo.items[0].bookingRef || ""
                  )?.then(() => {
                    setViatorReservationDetailsModalState({ show: false });
                  });
                }}
                t={t}
              />
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }, [
    viatorReservationDetailsModalState.show,
    viatorReservationDetailsModalState.reservationDetails,
    loadingReservation,
    t,
    reservationCancel,
  ]);

  /* */
  /* */
  /* ******* KIWI RESERVATION DETAILS ******* */
  const kiwiReservationDetailsModal = useMemo(() => {
    const kiwiReservationInfo = kiwiReservationDetailsModalState
      .reservationDetails?.value as
      | (Providers.Kiwi.KiwiReservationData & {
          hotelTitle?: string;
          hotelImage?: string;
          hotelCity?: string;
        })
      | undefined;

    return (
      <Modal
        show={kiwiReservationDetailsModalState.show}
        className="booking-modal p5"
        backdropClick={() => setKiwiReservationDetailsModalState({ show: false })}
      >
        <div className="row m0">
          <div className="travel-guide-modal-close-icon m2">
            <CloseIconButton
              fill="#fff"
              clicked={() => setKiwiReservationDetailsModalState({ show: false })}
            />
          </div>
          {kiwiReservationInfo ? (
            <div className="p-4">
              <h3 className="font-semibold mb-2">{kiwiReservationInfo.hotelTitle}</h3>
              {kiwiReservationInfo.hotelCity && <p>{kiwiReservationInfo.hotelCity}</p>}
              <p>{kiwiReservationInfo.roomTitle}</p>
              <p>{kiwiReservationInfo.rateTitle}</p>
              <p>{kiwiReservationInfo.inDate} — {kiwiReservationInfo.outDate}</p>
              <p>
                {kiwiReservationInfo.totalCostInclusive} {kiwiReservationInfo.currencyCode}
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Confirmation: {kiwiReservationInfo.confirmationId}
              </p>
              {kiwiReservationInfo.policies?.cancellation && (
                <p className="text-sm text-gray-500 mt-2">
                  {kiwiReservationInfo.policies.cancellation}
                </p>
              )}
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }, [kiwiReservationDetailsModalState]);

  /* */
  /* */
  /* ******* LIVN RESERVATION DETAILS ******* */
  const livnReservationDetailsModal = useMemo(() => {
    const livnReservationInfo = livnReservationDetailsModalState
      .reservationDetails?.value as
      | {
          livnReference: string;
          bookings: Providers.Livn.Booking[];
          tourName?: string;
          tourImage?: string;
          markupPerc?: number;
        }
      | undefined;

    return (
      <Modal
        show={livnReservationDetailsModalState.show}
        className="booking-modal p5"
        backdropClick={() => setLivnReservationDetailsModalState({ show: false })}
      >
        <div className="row m0">
          <div className="travel-guide-modal-close-icon m2">
            <CloseIconButton
              fill="#fff"
              clicked={() => setLivnReservationDetailsModalState({ show: false })}
            />
          </div>
          {livnReservationInfo ? (
            <div className="p-4">
              <h3 className="font-semibold mb-2">{livnReservationInfo.tourName}</h3>
              <p className="text-sm text-gray-500 mt-2 mb-3">
                Reference: {livnReservationInfo.livnReference}
              </p>
              <div className="flex flex-col gap-3">
                <LivnBookingTickets
                  bookings={livnReservationInfo.bookings ?? []}
                  markupPerc={livnReservationInfo.markupPerc}
                  tourName={livnReservationInfo.tourName}
                  fallbackTravelDate={livnReservationDetailsModalState.reservationDetails?.bookingDateTime}
                />
              </div>
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }, [livnReservationDetailsModalState]);

  const orderedModals = useMemo(() => {
    const oneModal = () => {
      if (yelpReservationDetailsModalState.show)
        return memoizedYelpReservationDetailsModal;
      if (gygReservationDetailsModalState.show)
        return gygReservationDetailsModal;
      if (viatorReservationDetailsModalState.show)
        return viatorReservationDetailsModal;
      if (kiwiReservationDetailsModalState.show)
        return kiwiReservationDetailsModal;
      if (livnReservationDetailsModalState.show)
        return livnReservationDetailsModal;
      return null;
    };

    return <>{oneModal()}</>;
  }, [
    gygReservationDetailsModal,
    gygReservationDetailsModalState.show,
    memoizedYelpReservationDetailsModal,
    viatorReservationDetailsModal,
    viatorReservationDetailsModalState.show,
    yelpReservationDetailsModalState.show,
    kiwiReservationDetailsModal,
    kiwiReservationDetailsModalState.show,
    livnReservationDetailsModal,
    livnReservationDetailsModalState.show,
  ]);

  const filteredUserReservations: Model.UserReservation[] =
    yelpReservations || [];

  const renderContent = () => {
    if (loadingReservations) return <PreLoading />;

    if (
      filteredUserReservations.length === 0 &&
      (!gygReservations || gygReservations.length === 0) &&
      (!viatorReservations || viatorReservations.length === 0) &&
      (!kiwiReservations || kiwiReservations.length === 0) &&
      (!livnReservations || livnReservations.length === 0)
    )
      return (
        <div className="center mt-8">
          <span>{t("trips.myTrips.itinerary.bookings.emptyMessage")}</span>{" "}
        </div>
      );

    return (
      <div className="flex flex-col justify-center items-center w-fit my-0 mx-auto p-4 rounded-2xl">
        {filteredUserReservations.map(yelpReservation => {
          const yelpReservationInfo =
            yelpReservation.value as Providers.Yelp.ReservationInfo;
          return (
            <BookingCard
              key={yelpReservationInfo.reservation_id}
              image={yelpReservationInfo.restaurant_image}
              title={yelpReservationInfo.restaurant_name}
              dateTime={`${yelpReservationInfo.reservation_details.date}${yelpReservationInfo.reservation_details.time ? `, ${yelpReservationInfo.reservation_details.time}` : ""}`}
              person={
                yelpReservationInfo.reservation_details.covers === 1
                  ? "1 person"
                  : `${yelpReservationInfo.reservation_details.covers} people`
              }
              provider="YELP"
              pastBooking={moment().isAfter(
                moment(yelpReservation.bookingDateTime)
              )}
              clicked={() =>
                setYelpReservationDetailsModalState({
                  show: true,
                  reservationDetails: yelpReservation,
                })
              }
              t={t}
            />
          );
        })}
        {gygReservations?.map(gygReservation => {
          const gygReservationInfo =
            gygReservation.value as Providers.Gyg.TourReservationDetails;
          const formattedImg = helper.getYourGuideImageFormat(
            gygReservationInfo.data.shopping_cart.tour_image,
            "60"
          );
          return (
            <BookingCard
              key={gygReservationInfo.data.shopping_cart.shopping_cart_hash}
              image={formattedImg}
              title={gygReservationInfo.data.shopping_cart.tour_name}
              dateTime={`${moment(gygReservationInfo.data.shopping_cart.bookings[0].bookable.datetime).format("MMM DD - HH:mm")}`}
              person={
                gygReservationInfo.data.shopping_cart.bookings.length === 1
                  ? "1 person"
                  : `${gygReservationInfo.data.shopping_cart.bookings.length} people`
              }
              provider="GETYOURGUIDE"
              pastBooking={moment().isAfter(
                moment(gygReservation.bookingDateTime)
              )}
              clicked={() =>
                setGygReservationDetailsModalState({
                  show: true,
                  reservationDetails: gygReservation,
                })
              }
              t={t}
            />
          );
        })}

        {viatorReservations
          ?.sort((a, b) =>
            moment(b.bookingDateTime).diff(moment(a.bookingDateTime))
          )
          .map(viatorReservation => {
            const viatorReservationInfo =
              viatorReservation.value as Providers.Viator.BookingReservationDetails;
            const numberOfTravelers = viatorReservationInfo?.items[0].lineItems
              ? viatorReservationInfo?.items[0].lineItems[0].numberOfTravelers
              : undefined;
            return (
              <BookingCard
                key={viatorReservationInfo.cartRef}
                image={viatorReservationInfo.tourImage}
                title={viatorReservationInfo.tourName}
                dateTime={`${viatorReservationInfo.availableDate}${viatorReservationInfo.selectedHour ? `, ${viatorReservationInfo.selectedHour}` : ""}`}
                person={
                  numberOfTravelers
                    ? numberOfTravelers === 1
                      ? `1 ${t("trips.myTrips.localExperiences.tourDetails.person")}`
                      : `${numberOfTravelers} ${t("trips.myTrips.localExperiences.tourDetails.people")}`
                    : undefined
                }
                status={viatorReservationInfo.items[0].status}
                provider="VIATOR"
                pastBooking={moment().isAfter(
                  moment(viatorReservation.bookingDateTime)
                )}
                clicked={() =>
                  setViatorReservationDetailsModalState({
                    show: true,
                    reservationDetails: viatorReservation,
                  })
                }
                t={t}
              />
            );
          })}

        {kiwiReservations?.map(kiwiReservation => {
          const kiwiReservationInfo = kiwiReservation.value as Providers.Kiwi.KiwiReservationData & {
            hotelTitle?: string;
            hotelImage?: string;
            hotelCity?: string;
          };
          return (
            <BookingCard
              key={kiwiReservationInfo.confirmationId}
              image={kiwiReservationInfo.hotelImage || ""}
              title={kiwiReservationInfo.hotelTitle || ""}
              dateTime={`${kiwiReservationInfo.inDate} — ${kiwiReservationInfo.outDate}`}
              person={
                kiwiReservationInfo.adults
                  ? `${kiwiReservationInfo.adults} ${Number(kiwiReservationInfo.adults) === 1 ? "person" : "people"}`
                  : undefined
              }
              provider="KIWI"
              pastBooking={moment().isAfter(moment(kiwiReservation.bookingDateTime))}
              clicked={() =>
                setKiwiReservationDetailsModalState({
                  show: true,
                  reservationDetails: kiwiReservation,
                })
              }
              t={t}
            />
          );
        })}

        {livnReservations?.map(livnReservation => {
          const livnReservationInfo = livnReservation.value as {
            livnReference: string;
            bookings: Providers.Livn.Booking[];
            tourName?: string;
            tourImage?: string;
          };
          return (
            <BookingCard
              key={livnReservationInfo.livnReference}
              image={livnReservationInfo.tourImage || ""}
              title={livnReservationInfo.tourName || ""}
              dateTime={moment(livnReservation.bookingDateTime).format("MMM DD, YYYY")}
              provider="LIVN"
              pastBooking={moment().isAfter(moment(livnReservation.bookingDateTime).endOf("day"))}
              clicked={() =>
                setLivnReservationDetailsModalState({
                  show: true,
                  reservationDetails: livnReservation,
                })
              }
              t={t}
            />
          );
        })}
      </div>
    );
  };

  return (
    <div className={bookingsContainerClasses.join(" ")}>
      <div className="sticky top-0 bg-white z-10 flex items-center justify-between px-8 mt-6 pb-6 mb-1 border-b border-[#D5D5D5]">
        <h3 className="font-medium text-xl">
          {t("trips.myTrips.itinerary.bookings.title")}
        </h3>
        <div className={`${classes.bookingsCloseIcon}`}>
          <CloseIconButton fill="#000" clicked={close} />
        </div>
      </div>
      <div className="scrollable-y" style={{ height: "calc(100% - 80px)" }}>
        {renderContent()}
      </div>
      {orderedModals}
    </div>
  );
};

export default MyBookingsContainer;
